import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const addBulkData = createAsyncThunk(
  "lotteries/addBulkData",
  async (lotteryData, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("lottery_brand_day_id", lotteryData.brandDate);
      formData.append("mega_prize", Number(lotteryData.megaPrice).toLocaleString());
      formData.append("draw_no", lotteryData.drawNo);
      formData.append("draw_date", lotteryData.drawDate);
      formData.append("count", lotteryData.count);
      formData.append("target_count", lotteryData.target_count);
      formData.append("start_serial", lotteryData.start_serial);
      formData.append("end_serial", lotteryData.end_serial);
      formData.append("price", lotteryData.price);
      formData.append("file", lotteryData.file);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      };

      const response = await axios.post(
        `${PUBLIC_BASE_URL}/tickets/lottery-tickets-upload`,
        formData,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          message: "Network Error",
          status: err.code,
          success: false,
        });
      } else {
        return rejectWithValue(err.response?.data || "Unknown error occurred.");
      }
    }
  }
);

export const addBulkResultData = createAsyncThunk(
  "lotteries/addBulkResultData",
  async (lotteryData, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("lottery_brand_day_id", lotteryData.brandDate);
      formData.append("draw_no", lotteryData.drawNo);
      formData.append("draw_date", lotteryData.drawDate);
      formData.append("file", lotteryData.file);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      };

      const response = await axios.post(
        `${PUBLIC_BASE_URL}/tickets/lottery-tickets-result-upload`,
        formData,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === "Network Error") {
        return rejectWithValue({
          message: "Network Error",
          status: err.code,
          success: false,
        });
      } else {
        return rejectWithValue(err.response?.data || "Unknown error occurred.");
      }
    }
  }
);
